module.exports = __webpack_public_path__ + "img/about-4-map.a09bc7a4.png";